"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _CompactCardView = _interopRequireDefault(require("../../../../CompactCardView"));
var _Alert = _interopRequireWildcard(require("../../../../ui/Alert"));
var _selectors = require("../../../../Baskets/store/selectors");
var _Claim = require("../../../../Baskets/components/Results/components/Claim");
var _pluralTranslations = require("../../../../../localization/pluralTranslations");
var _selectors2 = require("../../../../../bus/ui/selectors");
var _handlers = require("../../../../../helpers/handlers");
var _actions = require("../../store/actions");
var _helpers = require("../../helpers");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var noop = function noop() {};
var BasketItemPure = function BasketItemPure(_ref) {
  var basketID = _ref.basketID,
    offerID = _ref.offerID,
    isEditing = _ref.isEditing,
    isActive = _ref.isActive,
    onActive = _ref.onActive,
    _ref$onAdd = _ref.onAdd,
    onAdd = _ref$onAdd === void 0 ? noop : _ref$onAdd,
    _ref$onRemove = _ref.onRemove,
    onRemove = _ref$onRemove === void 0 ? noop : _ref$onRemove,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? noop : _ref$onOpen;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getBasketSimplifiedByID)(state, {
        basketID: basketID
      });
    }),
    image = _useSelector.image,
    title = _useSelector.title,
    offers = _useSelector.offers,
    date = _useSelector.date,
    claim = _useSelector.claim;
  var addOfferToBasketUIKey = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.getUI)(state, {
      key: (0, _helpers.getAddOfferToBasketUIKey)(basketID)
    });
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var toursTranslation = (0, _pluralTranslations.usePluralToursTranslation)();
  var isBasketContainsOffer = (0, _react.useMemo)(function () {
    return R.any(R.propEq(offerID, 'id'), offers);
  }, [offerID, offers]);
  var onEditTitle = (0, _react.useCallback)(function (newTitle, onSuccess) {
    return dispatch((0, _actions.updateBasketTitle)(basketID, newTitle, onSuccess));
  }, [basketID, dispatch]);
  var onClickAtBody = (0, _react.useCallback)(function (event) {
    if (onActive) {
      (0, _handlers.stop)(event);
      onActive(basketID);
    }
  }, [basketID, onActive]);
  var onRemoveProxy = (0, _react.useCallback)(function (event) {
    (0, _handlers.stop)(event);
    onRemove(basketID);
  }, [basketID, onRemove]);
  var onOpenProxy = (0, _react.useCallback)(function () {
    return onOpen(basketID);
  }, [basketID, onOpen]);
  return /*#__PURE__*/_react.default.createElement(_CompactCardView.default, {
    disabled: addOfferToBasketUIKey.loading,
    onClick: isBasketContainsOffer ? undefined : function () {
      return onAdd(basketID);
    }
  }, /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Image, {
    src: image ? (0, _dictionary.getImageUrl)(image, 'small') : undefined
  }), /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Body, {
    allowEditable: true,
    description: claim ? /*#__PURE__*/_react.default.createElement(_Claim.Claim, {
      description: claim.claimDesc,
      claimID: claim.id,
      className: _styles.default.claim,
      basketID: basketID
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.itemLength
    }, "".concat(offers.length, " ").concat(toursTranslation(offers.length))), /*#__PURE__*/_react.default.createElement("div", null, (0, _moment.default)(date).format('DD MMM HH:mm')), addOfferToBasketUIKey.error && /*#__PURE__*/_react.default.createElement(_Alert.default, {
      type: _Alert.TYPES.ERROR
    }, addOfferToBasketUIKey.message)),
    editing: isEditing,
    title: title,
    onClick: onClickAtBody,
    onEditTitle: onEditTitle
  }), onActive && /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Buttons, {
    loadingForArrowButton: isActive,
    collapseButtonClassName: _styles.default.arrowButton,
    onArrowButtonClick: function onArrowButtonClick() {
      return onActive(basketID);
    }
  }), isBasketContainsOffer && /*#__PURE__*/_react.default.createElement(_CompactCardView.default.SuccessOverlay, {
    onCancel: onRemoveProxy,
    onConfirm: onOpenProxy
  }));
};
BasketItemPure.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  offerID: _propTypes.default.string.isRequired,
  isEditing: _propTypes.default.bool,
  isActive: _propTypes.default.bool,
  onActive: _propTypes.default.func,
  onAdd: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  onOpen: _propTypes.default.func
};
var BasketItem = exports.BasketItem = (0, _react.memo)(BasketItemPure);